import angular from 'angular';
import '../node_modules/angular-touch/angular-touch.js';
import '../node_modules/angular-carousel/dist/angular-carousel.js';
import '../node_modules/angular-route/angular-route.js';
import '../node_modules/angular-animate/angular-animate.js';
import '../node_modules/restangular/dist/restangular.js';
import '../node_modules/heatmap.js/heatmap.js';
import '../node_modules/reductio/reductio.min.js';
import '../node_modules/angular-css/angular-css.js';
import '../node_modules/ng-resize/dist/ng-resize.js';
import '../node_modules/moment/moment.js';
import '../node_modules/moment/locale/ja.js';
import '../node_modules/ngstorage/ngStorage.min.js';
import '../node_modules/angular-cookies/angular-cookies.min.js';
import '../node_modules/angulartics/dist/angulartics.min.js';
import '../node_modules/angulartics-google-analytics/dist/angulartics-ga.min.js';
import '../node_modules/angular-bootstrap-datetimepicker/src/js/datetimepicker.js';
import '../scripts/datetimepicker-with-font-awesome.template.js';
import '../node_modules/angular-resource/angular-resource.js';
import '../node_modules/ng-file-upload/dist/ng-file-upload-shim.min.js';
import '../node_modules/ng-file-upload/dist/ng-file-upload.min.js';

angular.module('myApp', [
  'ngRoute',
  'mobile-angular-ui',
  'ngAnimate',
  'restangular',
  'angularDc',
  'angularCSS',
  'ngResize',
  'ui.bootstrap.datetimepicker',
  'angular-carousel',
  'ngCookies',
  'ngStorage',
  'ngTouch',
  'ngResource',
  'angulartics',
  'angulartics.google.analytics',
  'ngFileUpload'
])
.constant('apiEndpoint', '')
.config([
  '$routeProvider', '$locationProvider', '$analyticsProvider', 'Const',
  ($routeProvider, $locationProvider, $analyticsProvider, Const) => {
    /* @ngInject */
    let requireUserInfo = {
      userInfo: function ($q, $location, $sessionStorage) {
        let conditions;
        let sessionRole = $sessionStorage[Const.LSAPP_ROLE];
        let role = localStorage.getItem(Const.LSAPP_ROLE);
        $sessionStorage[Const.SSAPP_FULL_SCREEN_IOS] = false;

        // Cognito Credentials
        let userId = localStorage.getItem(Const.LSKEY_USER_ID);
        let jwtToken = localStorage.getItem(Const.LSKEY_USER_ID_TOKEN);
        let accessKeyId = localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID);
        let secretAccessKey = localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
        let sessionToken = localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN);
        let refreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
        let accessToken = localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN);
        let isCredential = false;
        if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
          isCredential = true;
        }
        let result;

        if (!sessionRole && role && isCredential) {
          // 別タブで開かれている場合で、sessionStorageは空だが、localStorageは残っている
          // 強制的にそれぞれのloginへ飛ばす
          $location.path('/simple-login');
          return $q.reject;
        }

        let isStaff = role === Const.LSAPP_ROLE_STAFF;
        let isReception = role === Const.LSAPP_ROLE_RECEPTION;
        let isSchoolAdmin = role === Const.LSAPP_ROLE_S_ADMIN;
        let isCompanyAdmin = role === Const.LSAPP_ROLE_C_ADMIN;
        let isMember = role === Const.LSAPP_ROLE_MEMBER;
        if (!role) {
          conditions = Const.CONDITIONS_TYPE.lackRole;
        } else if ((isStaff || isReception) && ($sessionStorage[Const.SSAPP_COACH_NAME] == null)) {
          conditions = Const.CONDITIONS_TYPE.lackStaffName;
        } else if (isSchoolAdmin && $sessionStorage[Const.SSAPP_SCHOOL_ID] == null) {
          conditions = Const.CONDITIONS_TYPE.lackSAdminSchoolId;
        } else if (isCompanyAdmin && $sessionStorage[Const.SSAPP_COMPANY_ID] == null) {
          conditions = Const.CONDITIONS_TYPE.lackCAdminCompanyId;
        } else if (isMember &&
          (!$sessionStorage[Const.SSAPP_USER_NAME] || $sessionStorage[Const.SSAPP_GENDER] == null)) {
          conditions = Const.CONDITIONS_TYPE.lackMemberDetail;
        }
        switch (conditions) {
          case Const.CONDITIONS_TYPE.lackRole:
            $location.path('/member/login');
            result = $q.reject;
            break;
          case Const.CONDITIONS_TYPE.lackStaffName:
          case Const.CONDITIONS_TYPE.lackSAdminSchoolId:
          case Const.CONDITIONS_TYPE.lackCAdminCompanyId:
            $location.path('/staff/login');
            result = $q.reject;
            break;
          case Const.CONDITIONS_TYPE.lackMemberDetail:
            $location.path('/member/login');
            result = $q.reject;
            break;
          default:
            result = $q.resolve;
        }
        return result;
      }
    };
    /* @ngInject */
    let requireTemplatePassword = {
      userInfo: function ($q, $location, $sessionStorage) {
        let sessionRole = $sessionStorage[Const.LSAPP_ROLE];
        let role = localStorage.getItem(Const.LSAPP_ROLE);
        $sessionStorage[Const.SSAPP_FULL_SCREEN_IOS] = false;

        // Cognito Credentials
        let userId = localStorage.getItem(Const.LSKEY_USER_ID);
        let jwtToken = localStorage.getItem(Const.LSKEY_USER_ID_TOKEN);
        let accessKeyId = localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID);
        let secretAccessKey = localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
        let sessionToken = localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN);
        let refreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
        let accessToken = localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN);
        let isCredential = false;
        if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
          isCredential = true;
        }
        let result;

        if (!sessionRole && role && isCredential) {
          // 別タブで開かれている場合で、sessionStorageは空だが、localStorageは残っている
          // 強制的にそれぞれのloginへ飛ばす
          $location.path('/simple-login');
          return $q.reject;
        }
        return result;
      }
    };
    $locationProvider.html5Mode(false);
    $routeProvider
    .when('/simple-login', {
      // 生徒サインイン
      templateUrl: 'app/components/simplicity-sign-in/simplicity-sign-in.html'
    })
    .when('/member/login', {
      // 生徒サインイン
      templateUrl: 'app/components/member-sign-in/member-sign-in.html'
    })
    .when('/member', {
      // 生徒トップ
      templateUrl: 'app/components/member-top/member-top.html',
      resolve: requireUserInfo
    })
    .when('/member/lesson', {
      // レッスン詳細
      templateUrl: 'app/components/lesson-detail/lesson-detail.html',
      resolve: requireUserInfo
    })
    .when('/member/video', {
      // レッスン動画再生
      templateUrl: 'app/components/video/play/video-play-screen.html',
      resolve: requireUserInfo
    })
    .when('/staff/login', {
      // スタッフサインイン
      templateUrl: 'app/components/coach-sign-in/coach-sign-in.html'
    })
    .when('/staff', {
      // スタッフトップ
      templateUrl: 'app/components/coach-top/coach-top.html',
      resolve: requireUserInfo
    })
    .when('/staff/school_list', {
      // スクールリスト
      templateUrl: 'app/components/school-list/school-list.html',
      resolve: requireUserInfo
    })
    .when('/staff/guest_video', {
      // ゲスト動画一覧
      templateUrl: 'app/components/guest-video/guest-video.html',
      resolve: requireUserInfo
    })
    .when('/staff/video_backlog', {
      templateUrl: 'app/components/video-backlog/video-backlog.html',
      resolve: requireUserInfo
    })
    .when('/staff/course', {
      // クラス詳細
      templateUrl: 'app/components/course-detail/course-detail.html',
      resolve: requireUserInfo
    })
    .when('/staff/member_detail', {
      // 生徒詳細
      templateUrl: 'app/components/member-detail/member-detail.html',
      resolve: requireUserInfo
    })
    .when('/admin/school', {
      // スクール一覧
      templateUrl: 'app/components/admin-school-list/admin-school-list.html',
      resolve: requireUserInfo
    })
    .when('/admin', {
      // Adminトップ
      templateUrl: 'app/components/admin-top/admin-top.html',
      resolve: requireUserInfo
    })
    .when('/admin/coach', {
      // Admin スタッフ一覧
      templateUrl: 'app/components/admin-coach-list/admin-coach-list.html',
      resolve: requireUserInfo
    })
    .when('/admin/member', {
      // Admin 生徒一覧
      templateUrl: 'app/components/admin-member-list/admin-member-list.html',
      resolve: requireUserInfo
    })
    .when('/admin/course', {
      // Admin コース一覧
      templateUrl: 'app/components/admin-course-list/admin-course-list.html',
      resolve: requireUserInfo
    })
    .when('/eula', {
      // menu: EULA/PP
      templateUrl: 'app/components/eula/eula.html',
      resolve: requireUserInfo
    })
    .when('/password_forget', {
      // menu: パスワード忘れ
      templateUrl: 'app/components/password-forget/password-forget.html'
    })
    .when('/password_change', {
      // menu: パスワード変更
      templateUrl: 'app/components/password-change/password-change.html',
      resolve: requireTemplatePassword
    })
    .when('/notification_configration', {
      // menu: 通知設定
      templateUrl: 'app/components/notification-configration/notification-configration.html',
      resolve: requireUserInfo
    })
    .otherwise({
      // 生徒サインイン
      redirectTo: '/member/login'
    });
    // Records pages that don't use $state or $route
    $analyticsProvider.firstPageview(true);
    // Records full path
    $analyticsProvider.withAutoBase(true);
  }])
  .constant('Const', {
    REGION: 'us-west-2',
    PROD_HOST_NAME: 'smarttennislesson.jp',
    // Dev環境用Cognito定義(member)
    DEV_USER_COGNITO_ID_POOL_ID: 'us-west-2:3fbe2586-b368-46cf-af19-dc76b0035bd1',
    DEV_USER_COGNITO_USER_POOL_ID: 'us-west-2_KS1Zl9yd5',
    DEV_USER_CLIENT_ID: '7lee1qp9pkat9967t4msfdmqcp',
    // Dev環境用Cognito定義(staff)
    DEV_STAFF_COGNITO_ID_POOL_ID: 'us-west-2:1e66fa53-bb50-488b-a350-140a1917f623',
    DEV_STAFF_COGNITO_USER_POOL_ID: 'us-west-2_Q52BKCSNd',
    DEV_STAFF_CLIENT_ID: '35pi0p0km7dckqck9ds3gbu10l',
    // Prod環境用Cognito定義(member)
    PROD_USER_COGNITO_ID_POOL_ID: 'us-west-2:3c0249b1-0ad7-4f8a-b69c-c9060c3a09f7',
    PROD_USER_COGNITO_USER_POOL_ID: 'us-west-2_z0AmoXg27',
    PROD_USER_CLIENT_ID: '7iid5qllaq6bm7gre8bh047i25',
    // Prod環境用Cognito定義(staff)
    PROD_STAFF_COGNITO_ID_POOL_ID: 'us-west-2:0959a472-f0cc-48cf-a70f-683658587bb2',
    PROD_STAFF_COGNITO_USER_POOL_ID: 'us-west-2_IsOeyRAEv',
    PROD_STAFF_CLIENT_ID: 'qcaoova3gvq2lgoets7loi7ap',
    LSKEY_USER_ID: 'userId',
    LSKEY_USER_ID_TOKEN: 'jwtToken',
    LSKEY_USER_ACCESS_KEY_ID: 'accessKeyId',
    LSKEY_USER_SECRET_ACCESS_KEY: 'secretAccessKey',
    LSKEY_USER_SESSION_TOKEN: 'sessionToken',
    LSKEY_USER_REFRESH_TOKEN: 'refreshToken',
    LSKEY_USER_ACCESS_TOKEN: 'accessToken',
    LSAPP_SCHOOL_NAME: 'schoolName',
    LSAPP_SCHOOL_ID: 'schoolId',
    LSAPP_MEMBER_NAME: 'memberName',
    LSAPP_MEMBER_ID: 'memberId',
    LSAPP_DISP_MEMBER_ID: 'displayMemberId',
    SSAPP_HAS_NETWORK_ERROR: 'hasNetworkError',
    SSAPP_HAS_REFRESH_OK: 'RefreshOk',
    SSAPP_HAS_REFRESH_ERROR: 'hasRefreshError',
    SSAPP_HAS_UNEXPECTED_ERROR: 'hasUnExpectedError',
    SSAPP_HAS_MAINTENANCE_ERROR: 'hasMaintenanceError',
    SSAPP_USER_NAME: 'userName',
    SSAPP_GENDER: 'gender',
    SSAPP_IS_TMP_PASSWORD: 'isTmpPassword',
    SSAPP_HAS_HEADER: 'hasHeader',
    SSAPP_HAS_GRAY: 'hasGray',
    SSAPP_COACH_NAME: 'coachName',
    SSAPP_COACH_GENDER: 'coachGender',
    SSAPP_COMPANY_ID: 'companyId',
    SSAPP_SCHOOL_ID: 'schoolId',
    SSAPP_SCHOOL_NAME: 'schoolName',
    SSAPP_COURSE_ID: 'courseId',
    SSAPP_MEMBER_ID: 'memberId',
    SSAPP_LESSON_BEGIN_DATE: 'lessonBeginDate',
    SSAPP_LESSON_END_DATE: 'lessonEndDate',
    SSAPP_LESSON_NAME: 'lessonName',
    SSAPP_LESSON_DATE: 'lessonDate',
    SSAPP_LESSON_DAY: 'lessonDay',
    SSAPP_LESSON_BEGIN_TIME: 'lessonBeginTime',
    SSAPP_LESSON_END_TIME: 'lessonEndTime',
    SSAPP_LESSON_COACH_NAME: 'lessonCoachName',
    SSAPP_LESSON_SUB_COACH_NAME: 'lessonSubCoachName',
    SSAPP_DISP_LESSON_INDEX: 'dispLessonIdx',
    SSAPP_DISP_LESSON_LIST: 'dispLessonList',
    SSAPP_TARGET_LESSON_INDEX: 'targetLessonIdx',
    SSAPP_TARGET_LESSON_LIST: 'targetLessonList',
    SSAPP_COURSE_INDEX: 'courseIdx',
    SSAPP_COURSE_LIST: 'courseList',
    SSAPP_SELECTED_YEAR_MONTH: 'selectedYearMonth',
    SSAPP_EULA_AGREE: 'eulaAgree',
    SSAPP_SENSOR_RENTAL: 'sensorRental',
    SSAPP_SMALL_HEIGHT: 'smallHeight',
    SSAPP_PRESIGNED_URLS: 'presignedUrls',
    SSAPP_MIN_HEIGHT: 'minHeight',
    SSAPP_PRIVATE_VIDEO_COMPLETE: 'privateVideoComplete',
    SSAPP_PUBLIC_VIDEO_COMPLETE: 'publicVideoComplete',
    SSAPP_PREVIEW_VIDEO_ON_COMPLETE: 'previewVideoOnComplete',
    SSAPP_PREVIEW_VIDEO_OFF_COMPLETE: 'previewVideoOffComplete',
    SSAPP_MOVE_VIDEO_TO_MEMBER_COMPLETE: 'moveVideoToMemberComplete',
    SSAPP_MOVE_VIDEO_TO_GUEST_COMPLETE: 'moveVideoToGuestComplete',
    SSAPP_ADMIN_COURSE_LIST_LOCATION: 'adminCourseListLocation',
    LSAPP_ROLE: 'role',
    LSAPP_ROLE_STAFF: 'staff',
    LSAPP_ROLE_RECEPTION: 'reception',
    LSAPP_ROLE_MEMBER: 'member',
    LSAPP_ROLE_C_ADMIN: 'companyAdmin',
    LSAPP_ROLE_S_ADMIN: 'schoolAdmin',
    SSAPP_IS_LOADING: 'isLoading',
    SSAPP_HEATMAP_FLG: 'heatmapFlg',
    SSAPP_SHOT_KIND: 'shotKind',
    SSAPP_RENDER_FIN: 'renderFin',
    SSAPP_FULL_SCREEN_IOS: 'fullScreenIOS',
    SSAPP_BROWSER_BACK_FORWARD: 'browserBackForward',
    SSAPP_OLD_LOCATION: 'oldLocation',
    SSAPP_BREAD_CRUMB_PATTERN: 'breadCrumbPattern',
    SSAPP_VIDEO_ID: 'videoId',
    SSAPP_VIDEO_ID_MOVE_TO_MEMBER: 'videoIdMoveToMember',
    SSAPP_MEMBER_ID_MOVE_TO_MEMBER: 'memberIdMoveToMember',
    SSAPP_SELECTED_DATE: 'selectedDate',
    ROLE_COACH: 'coach',
    CONDITIONS_TYPE: {
      lackRole: 1,
      lackStaffName: 2,
      lackSAdminSchoolId: 3,
      lackCAdminCompanyId: 4,
      lackMemberDetail: 5
    },
    ERROR_TYPE: {
      loginFailed: 0,
      samePassword: 1,
      prohibitionChars: 2,
      mismatchPassword: 3,
      pleaseInput: 4,
      passwordPolicy: 5,
      limit: 6,
      clear: 7
    },
    SHOT_TYPE: {
      all: 'すべてのショット',
      foreF: 'フォアハンド スピン/フラット',
      foreS: 'フォアハンド スライス',
      foreV: 'フォアハンド ボレー',
      backF: 'バックハンド スピン/フラット',
      backS: 'バックハンド スライス',
      backV: 'バックハンド ボレー',
      smash: 'スマッシュ',
      serve: 'サーブ'
    },
    SHOT_COLOR: {
      all: '#000000',
      foreF: '#ff6d1f',
      foreS: '#cb2020',
      foreV: '#517fb7',
      backF: '#800000',
      backS: '#793766',
      backV: '#12A1cb',
      smash: '#288666',
      serve: '#90aa40',
      deselected: '#b6b6b6'
    },
    GENDER_TYPE: {
      male: 1,
      female: 2
    },
    ADMIN_SCREEN_TYPE: {
      schoolList: 0,
      coachList: 1,
      memberList: 2,
      unknown: 99
    },
    EULA_AGREE_TYPE: {
      notAgree: 0,
      agreed: 1
    },
    SENSOR_RENTAL: {
      unRegistered: 0,
      registered: 1
    },
    COACH_TYPE: {
      sub: 0,
      main: 1
    },
    VIDEO_BACKLOG: {
      preview: 'preview',
      public: 'public'
    },
    VIDEO_BACKLOG_LABEL: {
      preview: 'プレビュー待ち',
      public: '公開待ち'
    },
    TITLE: {
      staffList: 'コーチ一覧 - Admim | スマートテニスレッスン',
      courseList: 'コース一覧 - Admim | スマートテニスレッスン',
      courseListForStaff: 'コース一覧 - Staff | スマートテニスレッスン',
      eula: '利用規約 | スマートテニスレッスン',
      signInForStaff: 'サインイン - Staff | スマートテニスレッスン',
      signIn: 'サインイン | スマートテニスレッスン',
      schoolList: 'クラブ選択 - Staff | スマートテニスレッスン',
      guestVideo: 'ゲスト動画一覧 - Staff | スマートテニスレッスン',
      videoBacklog: '動画公開状況 - Staff | スマートテニスレッスン',
      topForCompanyAdmin: 'トップ - Company Admin | スマートテニスレッスン',
      topForSchoolAdmin: 'トップ - School Admin | スマートテニスレッスン',
      topForStaff: 'トップ - Staff | スマートテニスレッスン',
      top: 'トップ | スマートテニスレッスン',
      lesson: 'レッスン詳細 | スマートテニスレッスン',
      memberListForAdmin: '生徒一覧 - Admim | スマートテニスレッスン',
      memberList: '生徒一覧 | スマートテニスレッスン',
      memberDetail: '生徒詳細 | スマートテニスレッスン',
      passForget: 'パスワードをお忘れの方 | スマートテニスレッスン',
      passChange: 'パスワード変更 | スマートテニスレッスン',
      notificationConfigration: '通知設定 | スマートテニスレッスン'
    },
    VIDEO_STATE_FLAG: {
      uploaded: 1,
      converted: 2,
      publiced: 4,
      previewed: 8
    },
    EXTERNAL_URL: {
      coachingVideos: 'https://www.s-re.jp/school/tennis/coach-movie/',
      howto: 'https://ict.sonynetwork.co.jp/sports/tennis/mykarte/stl_mykarte_howto.html'
    },
    ADMIN_COURSE_LIST_LOCATION: {
      adminTop: '/admin',
      coachTop: '/staff',
      guestVideo: '/staff/guest_video'
    },
    READ_MORE_LABEL: {
      open: '続きを読む',
      close: '閉じる'
    }
  });



// WEBPACK FOOTER //
// ./app/app.es6